import type { TranslationTag } from '@ps/web-core-intl';
import { getOverrideTranslation } from '@ps/web-shared-components';
import * as Sentry from '@sentry/react';
import { useCallback } from 'react';
import type { IntlFormatters } from 'react-intl';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { select } from '../store';

export const useRegulatoryIntl = () => {
  const { formatMessage: intlFormatMessage } = useIntl();

  const isSiteDE = useSelector(select.cms.isSiteDE);
  const showOntarioContent = useSelector(select.cms.showOntarioContent);

  const formatMessage = useCallback<IntlFormatters<React.ReactNode>['formatMessage']>(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- the consumer will receive the argument types from intlFormatMessage
    (descriptor: TranslationTag, ...restArgs: any[]) => {
      try {
        return intlFormatMessage(
          {
            ...descriptor,
            ...getOverrideTranslation({
              vegas: descriptor.vegas,
              ontario: descriptor.ontario,
              isSiteDE,
              showOntarioContent
            })
          },
          ...restArgs
        );
      } catch (error) {
        Sentry.captureException(error);
        return '';
      }
    },
    [intlFormatMessage, showOntarioContent, isSiteDE]
  );

  return { formatMessage };
};
